<template>
  <b-container>
    <b-row v-if="$store.state.logged">
      <b-col md="12" class="content_container">
        <FormSearchLocalisationUrgence></FormSearchLocalisationUrgence>
        <hr />
        <h4 class="text-left">Alertes en cours</h4>
        <b-row>
          <b-col md="3">
            <b-button class="inline-submenu-btn with_icon" @click="load_list()">
              <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon>
              Actualisation dans {{ refresh_in }}s</b-button
            >
            <div class="list_localisation" v-for="sos in list_sos" :key="sos.id">
              <div>
                <b>
                  {{ sos.nom }} {{ sos.prenom }} <span class="primary_color"><b> | </b></span> #{{ sos.doss }}</b
                >
                <b-button class="inline-submenu-btn btn-xs text-danger" @click="hide(sos.id)"><b-icon icon="trash" aria-hidden="true"></b-icon></b-button>
              </div>
              <div>Tel: {{ sos.tel }}</div>
              <div class="my-1">
                <span :class="'badge-status bg-' + get_badge_color(sos.status)"
                  >{{ sos.status }} <span v-if="sos.status == 'Localisation reçue'">(+/- {{ parseInt(sos.acc) }}m)</span></span
                >
              </div>
              <div>SMS envoyé: {{ get_time_formated(sos.timestamp) }}</div>
              <div v-if="sos.status == 'Localisation reçue' && sos.timestamp_locate != '0000-00-00 00:00:00'">Localisation reçue: {{ get_time_formated(sos.timestamp_locate) }}</div>
              <div>
                <b-button class="inline-submenu-btn btn-sm" @click="set_center_on(sos)"><b-icon icon="bullseye" aria-hidden="true"></b-icon> Localiser sur la carte</b-button>
              </div>
            </div>
          </b-col>
          <b-col md="9">
            <CarteLocalisation :list_sos="list_sos_has_location" :center_on="center_on"></CarteLocalisation>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import CarteLocalisation from "@/components/Live_tab/PCCourse/CarteLocalisation.vue";
import FormSearchLocalisationUrgence from "@/components/Live_tab/PCCourse/FormSearchLocalisationUrgence.vue";
import axios from "axios";
export default {
  components: { CarteLocalisation, FormSearchLocalisationUrgence },
  data() {
    return {
      center_on: null,
      list_sos: [],
      refresh_in: 30,
      current_interval: null,
    };
  },
  computed: {
    list_sos_has_location() {
      return this.list_sos.filter((sos) => sos.status == "Localisation reçue");
    },
  },
  methods: {
    set_center_on(sos) {
      this.center_on = sos;
    },
    async hide(id) {
      let request = await axios.get(this.$store.state.base_url + "/sos/hide.php?id_module=" + this.$store.state.module.id + "&id=" + id);
      if (request.data) {
        this.load_list();
      }
    },
    get_time_formated: function (timestamp) {
      return moment(timestamp).format("HH:mm:ss [le] DD/MM/YYYY");
    },
    get_badge_color: function (status) {
      if (status == "En attente de localisation") {
        return "warning";
      } else if (status == "Localisation reçue") {
        return "success text-white";
      } else {
        return "danger text-white";
      }
    },
    setup_auto_refresh: function () {
      this.current_interval = setInterval(() => {
        this.refresh_in--;
        if (this.refresh_in == 0) {
          this.load_list();
        }
      }, 1000);
    },
    async load_list() {
      this.refresh_in = 30;
      let request = await axios.get(this.$store.state.base_url + "/pc_course/list_sos/get.php?id_module=" + this.$store.state.module.id);
      if (request.data) {
        this.list_sos = request.data;
      }
    },
  },

  async created() {
    await this.load_list();
    this.setup_auto_refresh();
  },
};
</script>

<style lang="scss" scoped>
.list_localisation {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: flex-start;
  align-items: flex-start;
}
.badge-status {
  padding: 5px 12px;
  border-radius: 3px;
}
</style>